import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";
import { SidebarData } from "./SideBarData";
import "../css/Navbar.css";
import { IconContext } from "react-icons";
import { clearUser, getUserInfo } from "../localStorage";

const Sidebar = () => {
	const { fName, adminId } = getUserInfo();
	const [sidebar, setSidebar] = useState(false);

	const showSidebar = () => setSidebar(!sidebar);

	return (
		<>
			<IconContext.Provider value={{ color: "#2e2d2d" }}>
				<div className="navbar">
					<NavLink to="#" className="menu-bars">
						<FaIcons.FaBars onClick={showSidebar} />
					</NavLink>

					<nav className={sidebar ? "nav-menu active" : "nav-menu"}>
						<ul className="nav-menu-items" onClick={showSidebar}>
							<li className="navbar-toggle">
								<NavLink
									to="#"
									className="menu-bars navbar-close"
								>
									<AiIcons.AiOutlineClose />
								</NavLink>
							</li>

							<li>
								{fName ? (
									<li className="nav-text sideBarItemsName">
										<NavLink to="/">
											<FaIcons.FaUser />
											<span>{fName}</span>
										</NavLink>
									</li>
								) : (
									<li className="nav-text sideBarItemsName">
										<NavLink to="/login">
											<FaIcons.FaUser />
											<span>Sign in</span>
										</NavLink>
									</li>
								)}
							</li>

							{SidebarData.map((item, index) => {
								return (
									<li key={index} className={item.cName}>
										<NavLink
											to={item.path}
											className="sideBarItemsName"
										>
											{item.icon}
											<span>{item.title}</span>
										</NavLink>
									</li>
								);
							})}
							<li
								className="nav-text sideBarItemsName"
								onClick={() => clearUser()}
							>
								<NavLink to="/login">
									<FaIcons.FaSignOutAlt />
									<span>Sign out</span>
								</NavLink>
							</li>
							<li>
								{adminId === 'isCurrentAdmin' ? (
									<li className="nav-text sideBarItemsName">
										<NavLink to="/dashboard">
											<MdIcons.MdDashboard />
											<span>Dashboard</span>
										</NavLink>
									</li>
								) : (
									""
								)}
							</li>
						</ul>
					</nav>
				</div>
			</IconContext.Provider>
		</>
	);
};

export default Sidebar;
